import Vue from 'vue';
import Router from 'vue-router';

import UserFetch from '../fetch/user';

import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条样式

import NoNetwork from '@/components/page/NoNetwork';

import SchoolLogout from '@/components/page/SchoolLogout';
import Bill from '@/components/page/Bill';
import Message from '@/components/page/Message';
import User from '@/components/page/User';
import UserDetail from '@/components/page/UserDetail';
import UserEdit from '@/components/page/UserEdit';
import PhoneEdit from '@/components/page/PhoneEdit';
import FeedBack from '@/components/page/FeedBack';
// 我的战绩
import Profit from '@/components/page/Profit';
// 我的积分
import Score from '@/components/page/Score';
// 我的团队
import Member from '@/components/page/Member';
import Welcome from '@/components/page/Welcome';
// 提现
import WithDraw from '@/components/page/WithDraw';
// 战绩排行榜
import Rank from '@/components/page/Rank';
// 渠道信息
import Channel from '@/components/page/Channel';
// 朋友圈海报
import Poster from '@/components/page/Poster';
import ConfirmWithDraw from '@/components/page/ConfirmWithDraw';
import SchoolDetail from '@/components/page/SchoolDetail';
import Login from '@/components/page/Login';
import LoginCode from '@/components/page/LoginCode';
import LoginPasswd from '@/components/page/LoginPasswd';
import LoginShare from '@/components/page/LoginShare';
import ChangePassWord from '@/components/page/ChangePassWord';
import Invitation from '@/components/page/Invitation';
import DebugInfo from '@/components/page/DebugInfo';

import Container from '../utils/container';
import Auth from '../utils/auth';
// import WxSdk from '../utils/wxsdk';
import SiteEnv from '../utils/siteEnv';
import Trace from '../utils/trace';
Vue.use(Router);

const defaultTitle = SiteEnv.showSiteBase().pageTitle;

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'main',
      component: () => import('@/components/comm/Main'),
      redirect: '/school',
      children: [
        {
          path: '/school',
          name: 'school',
          component: () => import('@/components/page/School'),
          meta: {
            requireAuth: false,
            title: defaultTitle + '首页',
          },
        },
        {
          path: '/course/:courseId',
          name: 'courseDetail',
          component: SchoolDetail,
          props: true,
          meta: {
            requireAuth: true,
            title: '课程详情',
          },
        },

        {
          path: '/school/logout',
          name: 'schoolLogout',
          meta: {
            requireAuth: false,
          },
          component: SchoolLogout,
        },

        {
          path: '/bill',
          name: 'bill',
          meta: {
            requireAuth: true,
            title: '我的课程',
          },
          component: Bill,
        },

        {
          path: '/message',
          name: 'message',
          meta: {
            requireAuth: true,
            title: '消息盒子',
          },
          component: Message,
        },
        //----------------------以上是学院的路由。
        //----------------------以下是分销的路由。
        {
          path: '/user',
          name: 'user',
          component: User,
          meta: {
            requireAuth: true,
            title: '个人中心',
          },
        },
        {
          path: '/user/detail',
          name: 'detail',
          component: UserDetail,
          meta: {
            requireAuth: true,
            title: '用户详情',
          },
        },
        {
          path: '/user/edit',
          name: 'edit',
          component: UserEdit,
          meta: {
            requireAuth: true,
            title: '修改个人信息',
          },
        },
        {
          path: '/user/phone',
          name: 'phone',
          component: PhoneEdit,
          meta: {
            requireAuth: true,
            title: '修改手机号',
          },
        },
        {
          path: '/user/feedBack',
          name: 'feedBack',
          component: FeedBack,
          meta: {
            requireAuth: true,
            title: '用户反馈',
          },
        },
        {
          path: '/user/profit',
          name: 'profit',
          component: Profit,
          meta: {
            requireAuth: true,
            title: '我的战绩',
          },
        },
        {
          path: '/user/score',
          name: 'score',
          component: Score,
          meta: {
            requireAuth: true,
            title: '我的积分',
          },
        },
        { path: '/user/member', redirect: '/user/member/fans' },
        {
          path: '/user/member/:selectMemberType',
          name: 'member',
          props: true,
          component: Member,
          meta: {
            requireAuth: true,
            title: '我的团队',
          },
        },
        {
          path: '/user/withDraw',
          name: 'withDraw',
          component: WithDraw,
          meta: {
            requireAuth: true,
            title: '余额提现',
          },
        },
        {
          path: '/user/rank',
          name: 'rank',
          component: Rank,
          meta: {
            requireAuth: true,
            title: '零售排行榜',
          },
        },
        {
          path: '/network',
          name: 'network',
          meta: {
            requireAuth: false,
          },
          component: NoNetwork,
        },
        {
          path: '/user/channel',
          name: 'channel',
          component: Channel,
          meta: {
            requireAuth: true,
            title: '推广渠道',
          },
        },
        {
          path: '/user/poster',
          name: 'poster',
          component: Poster,
          meta: {
            requireAuth: true,
            title: '海报分享',
          },
        },
        {
          path: '/user/confirmWithDraw',
          name: 'confirmWithDraw',
          component: ConfirmWithDraw,
          meta: {
            requireAuth: true,
            title: '提现结果',
          },
        },
      ],
    },
    {
      path: '/loginCode',
      name: 'loginCode',
      component: LoginCode,
      meta: {
        requireAuth: false,
        title: '验证码登录',
      },
    },
    {
      path: '/login/passwd',
      name: 'loginPasswd',
      component: LoginPasswd,
      meta: {
        requireAuth: false,
        title: '密码登录',
      },
    },
    {
      path: '/login/setpwd',
      name: 'setPassword',
      component: LoginPasswd,
      meta: {
        requireAuth: true,
        title: '密码设置',
      },
    },
    {
      path: '/login/share',
      name: 'loginShare',
      component: LoginShare,
      meta: {
        requireAuth: true,
        title: '共享授权',
      },
    },
    {
      path: '/changePassword',
      name: 'changePassword',
      component: ChangePassWord,
      meta: {
        requireAuth: true,
        title: '设置密码',
      },
    },
    {
      path: '/ivt',
      name: 'invitation',
      component: Invitation,
      meta: {
        requireAuth: false,
      },
    },
    {
      path: '/login/:action',
      name: 'login',
      props: true, // params:action
      meta: {
        requireAuth: false,
      },
      component: Login,
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome,
      meta: {
        requireAuth: false,
      },
    },
    {
      path: '/debug/info',
      name: 'debugInfo',
      props: true, // params:action info
      meta: {
        requireAuth: false,
        title: '工程模式',
      },
      component: DebugInfo,
    },    {
      path: '/system/update',
      name: 'update',
      meta: {
        requireAuth: false,
        title: '系统升级',
      },
      component: () => import('@/components/page/SystemUpdate'),
    },
  ],
});

router.beforeEach( async (to, from, next) => {
  NProgress.start();
  //判断是否有网络
  if (!navigator.onLine) {
    return next({ path: '/network' });
  }
  // WxSdk.initWxSdk(to.path);

  //判断是否进入欢迎页面
  //	if(Container.localGet('comming') == null){
  //		Container.localSave('comming',true);
  //		return next({path:'/welcome'});
  //  }
  document.title = (to.meta && to.meta.title) || defaultTitle;

  Auth.discoverToken();
  await Trace.discoverIvt();

  if (!to.meta || to.meta.requireAuth) {
    var failLogin = to.query.failLogin; //前面是不是放弃登录了。
    let login = Auth.loginUser();
    if (failLogin) {
      //前面遇到问题放弃登录了，只能停止了。 TODO 弹窗
      console.log('登录失败');
      return next({ name: 'main' });
    } else if (!login) {
      //TODO 这里要注意，如何解决首次打开首页的时候发了两次同样的请求的问题
      return next({
        name: 'login',
        params: { action: 'begin' },
        query: { refer: to.fullPath },
      });
    }
  }
  return next();
});

//路由结束
router.afterEach(() => {
  NProgress.done(); // 结束Progress
});

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js